import React, { useEffect, useState } from 'react';
import { FiSettings } from "react-icons/fi";
import { AiOutlinePlus } from "react-icons/ai";
import { Link } from "react-router-dom";
import JobsTable from './jobs-table/JobsTable';
import { Pagination } from 'antd';

const Jobs = ({ data, total, handleDelete, getJobs, onChangeVal }) => {
  const [count, setCount] = useState([])
  console.log(data);

  useEffect(() => {
    if (data?.totalPages) {
      const arrr = []
      for (let i = 0; i < data.totalPages; i++) {
        arrr.push(i + 1)
      }
      setCount(arrr);
    }
  }, [data])
  return (
    <>
      <div className="pageTableWrapper">
        <div className="pageHeader">
          <div className="pageTitle">
            <FiSettings />
            <h5>Jobs</h5>
          </div>
          <div className="addNew">
            <Link to="/admin/create-job" className="btn btn-success">
              <AiOutlinePlus /> Add New Jobs
            </Link>
          </div>
        </div>

        <div className="pageBody">
          <JobsTable data={data?.data} handleDelete={handleDelete} />
        </div>

        <nav aria-label="Page navigation example">
          {/* <ul className="pagination"  style={{width:"400px" , overflow:"auto" , margin:"18px"}}>
            {count && count?.map((val)=>{
              return <li className="page-item" onClick={()=>{getJobs(val)}}><a className="page-link" href="#">{val}</a></li>
            })}
          </ul> */}
          {/* <Pagination
            defaultCurrent={1}
            onChange={onChangeVal}
            total={total}
          /> */}
        </nav>

        <div className="pageFooter">
          <div className="row">
            <div className="col-md-6">
              <div className="showEntry">
                <p>
                  Showing {total} entries
                </p>
              </div>
            </div>
            <div className="col-md-6">
              <div className="paginationPart">
                <Pagination
                  defaultCurrent={1}
                  onChange={onChangeVal}
                  total={total}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Jobs